export default __webpack_public_path__ + "static/media/ev-plug.20095999.jpeg";